export enum LogsServiceErrorCode {
  GENERAL,
}

export enum LogsAction {
  App = 'app',
  Find = 'find',
}

interface LogLookup {
  App: string
}

export interface LogLookupsServerData {
  Apps: LogLookup[]
}

interface Log {}

export type LogsServerData = Log[]

export interface LogsRequestAttributes {
  startDate: string
  endDate: string
  app: string
  module: string
  order: 'asc' | 'desc'
  tag: string
  level: string
  page: number
}

export interface GetLogsFailure {
  message: string
}
